import { useEffect, useState } from "react";
import { X, Download, ChevronLeft, ChevronRight, FileText } from "lucide-react";
import { downloadFile } from "@/lib/api";

// items: [{ src, name }]   index: number|null   setIndex: (n)=>void   onClose: ()=>void
export function Lightbox({ items, index, setIndex, onClose }) {
  const [err, setErr] = useState(false);
  useEffect(() => { setErr(false); }, [index]);
  useEffect(() => {
    const onKey = (e) => {
      if (index == null) return;
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") setIndex((index + 1) % items.length);
      if (e.key === "ArrowLeft") setIndex((index - 1 + items.length) % items.length);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [index, items, setIndex, onClose]);

  if (index == null || !items?.[index]) return null;
  const item = items[index];
  const many = items.length > 1;

  return (
    <div className="fixed inset-0 z-[100] bg-black/90 backdrop-blur-sm flex flex-col" data-testid="lightbox" onClick={onClose}>
      <div className="flex items-center justify-between p-4" onClick={(e) => e.stopPropagation()}>
        <div className="font-mono text-xs text-zinc-400 truncate max-w-[50%]">{item.name || "Attachment"}{many && <span className="text-zinc-600"> · {index + 1}/{items.length}</span>}</div>
        <div className="flex items-center gap-2">
          <button data-testid="lightbox-download" onClick={() => downloadFile(item.src, item.name || `attachment_${index + 1}`)} className="flex items-center gap-1 bg-[#FF5722] text-black border-2 border-black font-head font-bold uppercase text-xs px-3 py-2"><Download size={15} /> Save</button>
          <button data-testid="lightbox-close" onClick={onClose} className="text-zinc-300 hover:text-white p-2"><X size={22} /></button>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-4 relative" onClick={(e) => e.stopPropagation()}>
        {many && <button data-testid="lightbox-prev" onClick={() => setIndex((index - 1 + items.length) % items.length)} className="absolute left-2 text-white/70 hover:text-white p-2"><ChevronLeft size={40} /></button>}
        {err ? (
          <div className="text-center text-zinc-300">
            <FileText size={64} className="mx-auto text-[#FF5722]" />
            <p className="mt-3 font-mono text-sm">Preview unavailable for this document.</p>
            <a href={item.src} target="_blank" rel="noreferrer" className="inline-block mt-3 underline text-[#FF5722]">Open in new tab</a>
          </div>
        ) : (
          <img src={item.src} alt="" onError={() => setErr(true)} className="max-h-[80vh] max-w-full object-contain" />
        )}
        {many && <button data-testid="lightbox-next" onClick={() => setIndex((index + 1) % items.length)} className="absolute right-2 text-white/70 hover:text-white p-2"><ChevronRight size={40} /></button>}
      </div>
    </div>
  );
}
